import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function CategoryCards() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-4">
            浏览分类
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            按兴趣分类，快速找到你喜欢的白丝JK周边内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-2xl overflow-hidden bg-background-100 hover:bg-background-100/80 transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/90 text-background-50">
                    <i className={`${cat.icon} text-base`}></i>
                  </div>
                  <h3 className="font-heading text-lg text-background-50">{cat.name}</h3>
                </div>
                <p className="text-xs text-background-200/90 line-clamp-2 mt-1">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}